import { defineStore } from "pinia";
import { mockApi } from "@/mock/mockApi";

export const usePhieuCongStore = defineStore("phieuCong", {
  state: () => ({
    mySlip: null,
    adminList: [],
    adminDetail: null,
    loading: false,
    error: null,
  }),

  actions: {
    async fetchMy(month, userId) {
      this.loading = true;
      this.error = null;
      try {
        this.mySlip = await mockApi.mySlip({ month, userId });
      } catch (e) {
        this.error = e.message || String(e);
      } finally {
        this.loading = false;
      }
    },

    async signMy({ month, userId, name, imageDataUrl }) {
      this.loading = true;
      this.error = null;
      try {
        this.mySlip = await mockApi.sign({ month, userId, name, imageDataUrl });
      } catch (e) {
        this.error = e.message || String(e);
      } finally {
        this.loading = false;
      }
    },

    async fetchAdminList(month, status, keyword) {
      this.loading = true;
      this.error = null;
      try {
        this.adminList = await mockApi.adminList({ month, status, keyword });
      } catch (e) {
        this.error = e.message || String(e);
      } finally {
        this.loading = false;
      }
    },

    async fetchAdminDetail(id) {
      this.loading = true;
      this.error = null;
      try {
        this.adminDetail = await mockApi.adminDetail(id);
      } catch (e) {
        this.error = e.message || String(e);
      } finally {
        this.loading = false;
      }
    },

    async verify(id, note) {
      this.loading = true;
      this.error = null;
      try {
        this.adminDetail = await mockApi.verify({ id, note });
      } catch (e) {
        this.error = e.message || String(e);
      } finally {
        this.loading = false;
      }
    },

    async reject(id, reason) {
      this.loading = true;
      this.error = null;
      try {
        this.adminDetail = await mockApi.reject({ id, reason });
      } catch (e) {
        this.error = e.message || String(e);
      } finally {
        this.loading = false;
      }
    },
  },
});
